import { Environment } from './environment';

const chartColors = {
    [Environment.Staging]: {
        color0: '#006dea',
        color1: '#007eff',
        color2: '#4db5ff',
        color3: '#0086ff',
        color4: '#007eff',
        color5: '#00d4f2',
        color6: '#00cfff',
    },
    [Environment.Testing]: {
        color0: '#02a3b4',
        color1: '#00bbce',
        color2: '#18d9e9',
        color3: '#0087a3',
        color4: '#0087a3',
        color5: '#00d9d2',
        color6: '#00d9d2',
    },
    [Environment.Production]: {
        color0: '#5c45f2',
        color1: '#5f53e7',
        color2: '#ddbdff',
        color3: '#4e3efc',
        color4: '#9938ff',
        color5: '#d392ff',
        color6: '#d392ff',

    }
};

export default chartColors;